import type { LevelCopy } from "../levels/types";

export class WakeOverlay {
  private readonly root: HTMLDivElement;
  private readonly white: HTMLDivElement;
  private readonly loseTitle: HTMLParagraphElement;
  private readonly phrase: HTMLParagraphElement;
  private armed = false;
  private lastIndex = -1;
  private lastLose = -1;

  constructor(
    host: HTMLElement,
    onContinue: () => void,
    private readonly copy: LevelCopy,
  ) {
    this.root = document.createElement("div");
    this.root.className = "onirya-wake";
    this.root.setAttribute("aria-hidden", "true");

    this.white = document.createElement("div");
    this.white.className = "onirya-wake-white onirya-win-white";

    this.loseTitle = document.createElement("p");
    this.loseTitle.className = "onirya-lose-title";

    this.phrase = document.createElement("p");
    this.phrase.className = "onirya-win-phrase";

    this.root.addEventListener("pointerdown", (e) => {
      if (!this.armed) return;
      e.preventDefault();
      e.stopPropagation();
      this.armed = false;
      onContinue();
    });

    this.root.append(this.white, this.loseTitle, this.phrase);
    host.appendChild(this.root);
  }

  begin(kind: "win" | "lose"): void {
    this.root.classList.toggle("is-lose", kind === "lose");
    if (kind === "lose") {
      this.loseTitle.textContent = this.copy.loseTitle;
      const pool = this.copy.lose;
      if (pool.length === 0) {
        this.phrase.textContent = "";
        return;
      }
      let i = Math.floor(Math.random() * pool.length);
      if (pool.length > 1 && i === this.lastLose) {
        i = (i + 1) % pool.length;
      }
      this.lastLose = i;
      this.phrase.textContent = pool[i];
      return;
    }
    this.loseTitle.textContent = "";
    const pool = this.copy.win;
    if (pool.length === 0) {
      this.phrase.textContent = "";
      return;
    }
    let i = Math.floor(Math.random() * pool.length);
    if (pool.length > 1 && i === this.lastIndex) {
      i = (i + 1) % pool.length;
    }
    this.lastIndex = i;
    this.phrase.textContent = pool[i];
  }

  setWhite(opacity: number): void {
    this.white.style.opacity = String(opacity);
    this.root.classList.toggle("is-active", opacity > 0.01 || this.armed);
    this.root.setAttribute("aria-hidden", opacity > 0.01 || this.armed ? "false" : "true");
  }

  showPhrase(): void {
    if (this.loseTitle.textContent) this.loseTitle.classList.add("is-visible");
    this.phrase.classList.add("is-visible");
    this.root.classList.add("is-active");
    this.root.setAttribute("aria-hidden", "false");
  }

  arm(): void {
    this.armed = true;
  }

  reset(): void {
    this.armed = false;
    this.white.style.opacity = "0";
    this.loseTitle.classList.remove("is-visible");
    this.loseTitle.textContent = "";
    this.phrase.classList.remove("is-visible");
    this.phrase.textContent = "";
    this.root.classList.remove("is-active", "is-lose");
    this.root.setAttribute("aria-hidden", "true");
  }

  remove(): void {
    this.root.remove();
  }
}
